import { render, staticRenderFns } from "./companyApproval.vue?vue&type=template&id=e2d09b46&"
import script from "./companyApproval.vue?vue&type=script&lang=js&"
export * from "./companyApproval.vue?vue&type=script&lang=js&"
import style0 from "./companyApproval.vue?vue&type=style&index=0&id=e2d09b46&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports